import React from "react";
import styles from "./AppFooter.module.css";
import Logo_GreenRock_Text from "../assets/svgs/Logo_GreenRock_Text.svg";
import { Link } from "react-router-dom";

const AppFooter = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.topRow}>
        <div className={styles.socialLinks}>
          <div className={styles.link}>Instagram</div>
          <div className={styles.link}>Facebook</div>
        </div>
        <div className={styles.navLinks}>
          <Link className={styles.link} to="/">
            Home
          </Link>
          <Link className={styles.link} to="/certified-diamonds">
            Certified Diamonds
          </Link>
          {/* <Link className={styles.link} to="/events">
            Events
          </Link> */}
          <Link className={styles.link} to="/blog">
            Blogs
          </Link>
        </div>
        <div className={styles.navLinks}>
          <Link className={styles.link} to="/about">
            About
          </Link>
          <Link className={styles.link} to="/contact">
            Contact
          </Link>
          <Link className={styles.link} to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className={styles.link} to="/terms-and-condition">
            Terms & Condition
          </Link>
        </div>
        <div className={styles.copyright}>©2025</div>
      </div>
      <div className={styles.divider} />
      <div className={styles.branding}>
        <img
          src={Logo_GreenRock_Text}
          alt="Green Rock Logo"
          className={styles.brandMain}
        />
      </div>
      <a
        className={styles.designedBy}
        href="https://agendeas.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Design & Developed by agendeas solution
      </a>
    </footer>
  );
};

export default AppFooter;
